/*
 * Quantity-tier tile selector
 * --------------------------------------------------------------
 * Each tile carries data-qty="N". Clicking a tile sets the quantity
 * on the theme's quantity-selector-component so Add-to-Cart submits
 * with the right qty.
 *
 * The theme's product form reads quantity via
 *   quantity-selector-component.getValue()
 * which returns the .value of <input name="quantity">. Setting that
 * input directly works *if* the component is fully upgraded; we
 * defensively also call its public setValue() and as a last resort
 * simulate +/- button clicks, which always go through the component's
 * own state machine.
 */

(function () {
  function init() {
    document.querySelectorAll('[data-qty-tiers]').forEach(setup);
  }

  function setup(container) {
    const tiers = container.querySelectorAll('.qty-tier');
    if (!tiers.length) return;

    const scope =
      container.closest('product-info') ||
      container.closest('.product-details') ||
      container.closest('[data-section]') ||
      document;

    tiers.forEach((tier) => {
      tier.addEventListener('click', (event) => {
        event.preventDefault();
        selectTier(tiers, tier, scope);
      });
    });
  }

  function selectTier(allTiers, selected, scope) {
    allTiers.forEach((t) => {
      const isActive = t === selected;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const targetQty = parseInt(selected.dataset.qty, 10) || 1;
    applyQuantity(scope, targetQty);
  }

  function applyQuantity(scope, targetQty) {
    const component = scope.querySelector('quantity-selector-component');
    const input = scope.querySelector('input[name="quantity"]');

    // 1) Public API on the upgraded custom element.
    if (component && typeof component.setValue === 'function') {
      try {
        component.setValue(String(targetQty));
      } catch (_) {
        /* ignore — fall through to direct input */
      }
    }

    // 2) Direct input value (covers the case where the component
    //    isn't upgraded yet, and is what the theme's getValue()
    //    reads back at submit time).
    if (input) {
      input.value = String(targetQty);
      input.setAttribute('value', String(targetQty));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // 3) Belt-and-suspenders: simulate +/- clicks so the component's
    //    own state machine settles on the target. Skips itself if
    //    setValue() above already landed the right number.
    const currentValue = input ? parseInt(input.value, 10) || 0 : 0;
    if (currentValue !== targetQty && component) {
      const plus = component.querySelector('button[name="plus"]');
      const minus = component.querySelector('button[name="minus"]');
      const diff = targetQty - currentValue;
      if (diff > 0 && plus) {
        for (let i = 0; i < diff; i++) plus.click();
      } else if (diff < 0 && minus) {
        for (let i = 0; i < -diff; i++) minus.click();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
